import React, { createContext, useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'

export const Context = createContext({})

export const Provider = ({ children }) => {
  const { allSanityEmployee: { nodes: employees } } = useStaticQuery(query)

  const [$active, set$active] = useState(false)

  return <Context.Provider
    value={{
      employees,
      $active, set$active,
    }}
    children={children}
  />
}

const query = graphql`query EmployeeList {
  allSanityEmployee(sort: {fields: orderRank}) {
    nodes {
      _id
      title
      name
      education
      licenses
      certs
      _rawRole
      experiences {
        _rawContent
      }
    }
  }
}`
